import React from "react";
import "../styles/main.scss";

const RulesPage = () => {
  return (
    <div className="container page">
      <h2>Regelwerk</h2>
      <p>Hier findest du alle Regeln für das Spiel.</p>
    </div>
  );
};

export default RulesPage;
